import Pagination from './Pagination';
import PaginationPrevious from './PaginationPrevious';
import PaginationNext from './PaginationNext';
import PaginationPreviousIcon from './PaginationPreviousIcon';
import PaginationNextIcon from './PaginationNextIcon';
import PaginationCount from './PaginationCount';
import {Plugins, ElementPreset, Component} from '@packages/systems/wfdl';
import {qualify, iconName} from '@packages/systems/wfdl-Qualified';
import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  EList,
  EEnum,
} from '@packages/systems/wfdl-ast';
import PaginationType from './dataTypes/PaginationType';
import ShowPageCountType from './dataTypes/ShowPageCountType';
import {ElementPaginationIcon as PaginationIcon} from '@packages/systems/spring';

export const plugin = Plugins.PrivilegedPlugin({
  icons: {
    Pagination: PaginationIcon,
  },
  atoms: {
    Pagination,
    PaginationPrevious,
    PaginationNext,
    PaginationPreviousIcon,
    PaginationNextIcon,
    PaginationCount,
  },
  dataTypes: {
    Pagination: PaginationType,
    ShowPageCount: ShowPageCountType,
  },
  elementPresets: {
    Pagination: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Pagination'), iconName('Pagination')),
        medium: qualify(Plugins.name('Pagination'), iconName('Pagination')),
      },
      label: 'Pagination',
      factory: EElement({
        id: 'Pagination',
        type: qualify(Plugins.name('Pagination'), Component.name('Pagination')),
        data: ERecord({
          tag: EEnum('div'),
          children: EList([
            EElement({
              id: 'Pagination Previous',
              type: qualify(
                Plugins.name('Pagination'),
                Component.name('PaginationPrevious')
              ),
              data: ERecord({
                tag: EText('a'),
                children: EList([
                  EElement({
                    id: 'Pagination Previous Icon',
                    type: qualify(
                      Plugins.name('Pagination'),
                      Component.name('PaginationPreviousIcon')
                    ),
                    data: ERecord({}),
                  }),
                  EElement({
                    id: 'Block',
                    type: qualify(
                      Plugins.name('Basic'),
                      Component.name('Block')
                    ),
                    data: ERecord({
                      tag: EEnum('div'),
                      text: EBoolean(true),
                      block: EText('inline'),
                      children: EList([
                        EElement({
                          id: 'String',
                          type: qualify(
                            Plugins.name('Basic'),
                            Component.name('String')
                          ),
                          data: EText('Previous'),
                        }),
                      ]),
                    }),
                  }),
                ]),
              }),
            }),
            EElement({
              id: 'Pagination Next',
              type: qualify(
                Plugins.name('Pagination'),
                Component.name('PaginationNext')
              ),
              data: ERecord({
                tag: EText('a'),
                children: EList([
                  EElement({
                    id: 'Block 2',
                    type: qualify(
                      Plugins.name('Basic'),
                      Component.name('Block')
                    ),
                    data: ERecord({
                      tag: EEnum('div'),
                      text: EBoolean(true),
                      block: EText('inline'),
                      children: EList([
                        EElement({
                          id: 'String 2',
                          type: qualify(
                            Plugins.name('Basic'),
                            Component.name('String')
                          ),
                          data: EText('Next'),
                        }),
                      ]),
                    }),
                  }),
                  EElement({
                    id: 'Pagination Next Icon',
                    type: qualify(
                      Plugins.name('Pagination'),
                      Component.name('PaginationNextIcon')
                    ),
                    data: ERecord({}),
                  }),
                ]),
              }),
            }),
          ]),
        }),
      }),
      category: null,
    }),
  },
});
